import classNames from "classnames";
import React, {
    HTMLAttributes,
    ReactElement,
    ReactNode,
} from "react";

export const SIZES = ["small", "medium", "large"] as const;
export const VARIANT = [
    "danger", "warning", "yield", "success", "info", "primary", "gray",
    "main", "attention", "counter",
] as const;
export type VariantType = typeof VARIANT[number];
export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
    size?: typeof SIZES[number];
    variant?: VariantType;
    prefixIcon?: ReactNode;
    postfixIcon?: ReactNode;
    isRounded?: boolean;
    isSelected?: boolean;
}

const Badge = React.forwardRef((
    args: BadgeProps,
    ref: React.ForwardedRef<HTMLSpanElement>,
): ReactElement => {
    const {
        size, variant, prefixIcon, postfixIcon, isRounded, isSelected, ...rest
    } = args;

    return (
        <span
            {...rest}
            ref={ref}
            className={classNames(
                "badge",
                variant ? `badge-${variant}` : "",
                size ? `badge-${size}` : "",
                args.className,
                !args.children ? "badge-icon-only" : "",
                isRounded ? "rounded" : "",
                isSelected ? "badge-selected" : "",
            )}
        >
            {prefixIcon && (
                <span className="badge-icon badge-prefix-icon">
                    {prefixIcon}
                </span>
            )}

            {args.children}

            {postfixIcon && (
                <span className="badge-icon badge-postfix-icon">
                    {postfixIcon}
                </span>
            )}

        </span>
    );
});

Badge.defaultProps = {
    variant: undefined,
    className: "",
    prefixIcon: undefined,
    size: "medium",
    isRounded: false,
    isSelected: false,
};

export default Badge;
